<template>
    <SettingsCard title="Обеденные перерывы">
        <template #actions>
            <btn v-if="!showAddForm && !loadError" @click="add">Добавить правило</btn>
        </template>

        <div v-if="loadError" class="ds-settings-lunch-state-error" role="alert">
            <span>Не удалось загрузить правила обеденных перерывов.</span>
            <btn @click="emit('retry-load')">Повторить</btn>
        </div>
        <template v-else>
            <div v-if="!lunches.length && !showAddForm" class="ds-settings-lunch-state">
                Правил пока нет. Добавьте первое правило.
            </div>
            <div v-for="(lunch, index) in lunches" :key="lunch.id" class="ds-settings-lunch-row">
                <LunchItem :lunch @edit="onEdit" @delete="onDelete" :prev="getPrevLunch(index)" :next="getNextLunch(index)" />
            </div>
            <AddLunch v-if="showAddForm" @cancel="onCancel" @create="onCreate" :lunches />
        </template>

        <div v-if="operationError" class="ds-settings-lunch-state-error ds-settings-lunch-operation-error" role="alert">
            {{ operationErrorMessage }} <button type="button" @click="retryOperation">Повторить</button>
        </div>
    </SettingsCard>
</template>

<script setup lang="ts">
import { useSettingsStore } from '@/stores/settingsStore';
import { computed, ref } from 'vue';
import LunchItem from './LunchItem.vue';
import AddLunch from './AddLunch.vue';
import SettingsCard from '@/ui/SettingsCard.vue';


defineProps<{
    loadError: boolean
}>()

const emit = defineEmits<{
    (event: 'retry-load'): void
}>()

const settingsStore = useSettingsStore()

const lunches = computed(() => settingsStore.lunchSettings)
const showAddForm = ref(false)
const operationError = ref(false)
const operationErrorMessage = ref('')
const retryRequest = ref<(() => Promise<void>) | null>(null)

const handleResult = (error: unknown, retry: () => Promise<void>, message: string) => {
    operationError.value = Boolean(error)
    operationErrorMessage.value = error ? message : ''
    retryRequest.value = error ? retry : null
}

const onCreate = async (data: any) => {
    const request = async () => {
        const error = await settingsStore.createLunch(data)
        handleResult(error, request, 'Не удалось создать правило.')
        if (!error) showAddForm.value = false
    }

    await request()
}

const onEdit = async (data:any) => {
    const request = async () => {
        const error = await settingsStore.editLunchSettings(data.id, data)
        handleResult(error, request, 'Не удалось сохранить изменения правила.')
    }

    await request()
}

const onDelete = async (id:string) => {
    const request = async () => {
        const error = await settingsStore.removeLunch(id)
        handleResult(error, request, 'Правило скрыто из списка, но не удалено на сервере.')
    }

    await request()
}

const add = () => {
    showAddForm.value = true
}

const onCancel = () => {
    showAddForm.value = false
}

const retryOperation = async () => {
    await retryRequest.value?.()
}

const getPrevLunch = (index: number) => (index) ? lunches.value[index-1] : null
const getNextLunch = (index: number) => (index < lunches.value.length-1) ? lunches.value[index+1] : null
</script>
